







import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./HoroscopeList.css";

import Aries from "../../assets/image/aries.png";
import Taurus from "../../assets/image/taurus.png";
import Gemini from "../../assets/image/gemini.png";
import Cancer from "../../assets/image/cancer.png";
import Leo from "../../assets/image/lio.png";
import Virgo from "../../assets/image/virgo.png";
import Libra from "../../assets/image/libra.png";
import Scorpio from "../../assets/image/scorpio.png";
import Sagittarius from "../../assets/image/sagittarius.png";
import Capricorn from "../../assets/image/capricorn.png";
import Aquarius from "../../assets/image/aquarius.png";
import Pisces from "../../assets/image/pisces.png";

const zodiacSigns = [
  { name: "Aries", id: 1, img: Aries },
  { name: "Taurus", id: 2, img: Taurus },
  { name: "Gemini", id: 3, img: Gemini },
  { name: "Cancer", id: 4, img: Cancer },
  { name: "Leo", id: 5, img: Leo },
  { name: "Virgo", id: 6, img: Virgo },
  { name: "Libra", id: 7, img: Libra },
  { name: "Scorpio", id: 8, img: Scorpio },
  { name: "Sagittarius", id: 9, img: Sagittarius },
  { name: "Capricorn", id: 10, img: Capricorn },
  { name: "Aquarius", id: 11, img: Aquarius },
  { name: "Pisces", id: 12, img: Pisces },
];

const HoroscopeList = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  const handleButtonClick = (sign, type) => {
    const lang = "en";
    let url = "";

    if (type === "daily") {
      url = `https://api.jyotishamastroapi.com/api/prediction/daily?zodiac=${sign.id}&day=tomorrow&lang=${lang}`;
    } else if (type === "weekly") {
      url = `https://api.jyotishamastroapi.com/api/prediction/weekly?zodiac=${sign.id}&lang=${lang}`;
    } else if (type === "monthly") {
      url = `https://api.jyotishamastroapi.com/api/prediction/monthly?zodiac=${sign.id}&lang=${lang}`;
    }

    navigate(`/horoscope/${sign.name}`, { state: { url, type, sign } });
  };

  return (
    <div className="horoscope-wrapper">
      <div className="container">
        <h2 className="home-horoscope-title">
          Horo<span>Scopes</span>
        </h2>
        <h2 className="horoscope-heading">
          Daily horoscopes are like a guiding light in the vast universe of possibilities.
        </h2>

        <div className="row">
          <div className="ra-horoscope-main-card">
            {zodiacSigns.map((sign, i) => (
              <div
                key={i}
                className="ra-horoscope-card-collum"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="ra-horoscope-card">
                  <img src={sign.img} alt={sign.name} />
                  <h3>{sign.name}</h3>

                  {hoveredIndex === i && (
                    <div className="horoscope-buttons">
                      <button onClick={() => handleButtonClick(sign, "daily")}>Daily</button>
                      <button onClick={() => handleButtonClick(sign, "weekly")}>Weekly</button>
                      <button onClick={() => handleButtonClick(sign, "monthly")}>Monthly</button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoroscopeList;





















